import { devtools, subscribeWithSelector } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { createStore } from 'zustand/vanilla';
const mediaStoreWithoutDevtools = createStore()(subscribeWithSelector(immer(() => ({
  files: {}
}))));
const mediaStoreWithDevtools = createStore()(devtools(subscribeWithSelector(immer(() => ({
  files: {}
})))));
export const mediaStore = process.env.NODE_ENV === 'development' && !process.env.CI ? mediaStoreWithDevtools : mediaStoreWithoutDevtools;
export const createMediaStore = initialStore => {
  return createStore()(subscribeWithSelector(immer(() => ({
    files: {},
    ...initialStore
  }))));
};